import React from 'react';

const ProgressBar = ({ percentage = 0, height = 20, variant = 'danger' }) => {
  const validatedPercentage = Math.min(Math.max(percentage, 0), 100); // Clamp between 0–100

  return (
    <div className="progress bg-light-subtle" style={{ height }}>
      <div
        className={`progress-bar bg-${variant}`}
        role="progressbar"
        style={{
          width: `${validatedPercentage}%`,
          height: `${height}px`,
          color: `#fff`,
          fontWeight: `600`,
        }}
        aria-valuenow={validatedPercentage}
        aria-valuemin="0"
        aria-valuemax="100"
      >{validatedPercentage}%</div>
    </div>
  );
};

export default ProgressBar;
